import React, { useEffect, useState } from "react";
import { InvoiceHeader } from "../components/masterInvoiceDetals/InvoiceHeader";
import { InvoiceTotals } from "../components/masterInvoiceDetals/Totals";
import { InvoiceItemsTable } from "../components/masterInvoiceDetals/InvoiceItemTable";
import { Milestones } from "../components/masterInvoiceDetals/Milestone";
import { useParams } from "react-router-dom";
import { makeDetailedFetchInvoiceData } from "./Api";
import ErrorMessage from "../components/error/Error";
import Loading from "../components/loading/Loading";
import LoaderOverlay from "../components/loading/GlobalLoader";
import { FaFilePdf } from "react-icons/fa";
import { motion, AnimatePresence } from "framer-motion";
import { PDFGenerator } from "../components/masterInvoiceDetals/PDFGenerator";
import { PDFGeneratorDuna } from "../components/masterInvoiceDetals/PDFGeneratorDuna";
export default function InvoiceDetailPage() {
  const { masterInvoiceId } = useParams();
  const [data, setData] = useState();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [showOptions, setShowOptions] = useState(false);

  const fetchData = async () => {
    if (!masterInvoiceId.trim()) return;
    setLoading(true);
    setError(null);
    try {
      const responseData = await makeDetailedFetchInvoiceData(masterInvoiceId.trim());
      setData(responseData);
    } catch (err) {
      setError("Failed to fetch invoice data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, [masterInvoiceId]);

  const handleDownloadPDF1 = () => {
    PDFGenerator(data);
  };

  const handleDownloadPDF2 = () => {
    PDFGeneratorDuna(data);
  };

  console.log(data,"Master Invoice Data")

  return (
    <>
      <LoaderOverlay isLoading={loading} />
      <ErrorMessage error={error} show={error} />
      <motion.div 
        initial={{ opacity: 0, y: 20 }} 
        animate={{ opacity: 1, y: 0 }} 
        transition={{ duration: 0.5 }}
        className="max-w-[80%] mx-auto p-6 bg-white shadow-lg rounded-lg"
      >
        {data && (
          <>
            <InvoiceHeader data={data} />
            <InvoiceItemsTable items={data.invoiceItems} />
            <InvoiceTotals totals={data.totals} />
            <Milestones data={data} invoiceId={data.id} milestonesData={data.Milestone} fetchData={fetchData} />
          </>
        )}
      </motion.div>

      {/* Floating PDF Button */}
      <motion.button
        onClick={() => setShowOptions(!showOptions)}
        initial={{ scale: 0 }}
        animate={{ scale: 1 }}
        whileHover={{ scale: 1.1 }}
        whileTap={{ scale: 0.9 }}
        transition={{ type: "spring", stiffness: 300 }}
        className="fixed bottom-6 right-6 bg-gradient-to-r from-red-500 to-pink-500 text-white p-4 rounded-full shadow-xl hover:bg-red-700 flex items-center justify-center"
      >
        <FaFilePdf size={24} />
      </motion.button>

      {/* Two PDF Download Buttons */}
      <AnimatePresence>
      {showOptions && (
        <div className="fixed bottom-28 right-6 flex flex-col gap-3">
          <motion.button
            onClick={handleDownloadPDF1}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            whileHover={{ scale: 1.1 }}
            className="bg-gradient-to-r from-blue-500 to-purple-500 text-white p-3 rounded-xl shadow-lg flex items-center gap-3 transition-all duration-300 hover:from-purple-500 hover:to-blue-500 backdrop-blur-md bg-opacity-80"
          >
            <FaFilePdf size={22} />
            <span className="font-semibold">Trigon</span>
          </motion.button>

          <motion.button
            onClick={handleDownloadPDF2}
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 50 }}
            whileHover={{ scale: 1.1 }}
            className="bg-gradient-to-r from-green-500 to-teal-500 text-white p-3 rounded-xl shadow-lg flex items-center gap-3 transition-all duration-300 hover:from-teal-500 hover:to-green-500 backdrop-blur-md bg-opacity-80"
          >
            <FaFilePdf size={22} />
            <span className="font-semibold">Dunes</span>
          </motion.button>
        </div>
      )}
    </AnimatePresence>
    </>
  );
}
